import { render, staticRenderFns } from "./BaskoNextGenLatestPosts.vue?vue&type=template&id=587118aa&scoped=true"
import script from "./BaskoNextGenLatestPosts.vue?vue&type=script&lang=js"
export * from "./BaskoNextGenLatestPosts.vue?vue&type=script&lang=js"
import style0 from "./BaskoNextGenLatestPosts.vue?vue&type=style&index=0&id=587118aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587118aa",
  null
  
)

export default component.exports